<div class="loading-overlay" *ngIf="loadingService.isLoading$ | async">
  <div class="image-container">
    <img *ngFor="let img of images" [src]="img" [class.active]="currentImage === img" class="loading-image"
      alt="Loading">
    <div class="logo-container">
     <img src="assets/imgs/logo.svg" alt="Logo">
    </div>
  </div>

  <div class="progress-container">
    <span class="progress-value">{{progressValue}}%</span>
    <div class="progress-bar" [style.width.%]="progressValue">
    </div>
  </div>
</div>